import $ from 'jquery';
import formatCaptions from './formatCaptions';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatCaptions(`[data-section-id="${e.detail.sectionId}"]`);
  });
};